import { render, staticRenderFns } from "./install-type-field.vue?vue&type=template&id=01e65ab1&"
import script from "./install-type-field.vue?vue&type=script&lang=js&"
export * from "./install-type-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports